import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Router } from '@angular/router';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { OauthService } from './oauth.service';
import { AppSnackService } from './snack-service.service';
import { NetworkService } from './network-service.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private authService: OauthService,
    private snackSrv: AppSnackService,
    private netSrv: NetworkService,
    private router: Router,
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    let clonedRequest = request;
    const token = this.authService.getToken();

    // Verifica que exista y no haya expirado.
    if (token && !this.authService.isTokenExpired(token)) {
      clonedRequest = request.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
      });
    }

    // Envía la petición, con el token, al siguiente manejador en la cadena.
    return next.handle(clonedRequest).pipe(
      catchError((error: any) => {
        if (!(error instanceof HttpErrorResponse)) {
          return throwError(() => error);
        }

        if (error.status === 0 || !this.netSrv.isOnline()) {
          return throwError(() => error);
        }

        if (error.status === 401 && !request.url.includes('/login')) {
          this.snackSrv.openWithContext('Sesión vencida', 'warning');
          this.authService.handleUnauthorized();
          return EMPTY;
        }

        if (error.status === 403) {
          this.snackSrv.openWithContext(
            'No tenés permisos para esta sección',
            'warning',
          );
          this.router.navigate(['/inicio']);
          return EMPTY;
        }

        return throwError(() => error);
      }),
    );
  }
}
